import { InputV2 } from '@southfields-digital/mpxlive-components';
import { useEffect, useState } from 'react';

type ShortNameInputProps = {
  value: string;
  onChange: (value: string) => void;
};

const ShortNameInput = ({ value, onChange }: ShortNameInputProps) => {
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLocalValue(e.target.value);
  };

  const propagate = (val: string) => {
    if (val !== value) onChange(val);
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    propagate(e.target.value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') propagate(localValue);
  };

  return (
    <InputV2
      type="text"
      inputSize="lg"
      className="text-center text-lg w-12 min-w-0"
      value={localValue}
      onChange={handleChange}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
    />
  );
};

export default ShortNameInput;
